import { Component, OnInit, Input, EventEmitter, Output } from '@angular/core';
import { camps } from '../../models/models.generated';

@Component({
    selector: 'app-club-select',
    templateUrl: './club-select.component.html',
    styleUrls: ['./club-select.component.scss'],
    standalone: false
})
export class ClubSelectComponent implements OnInit {

    @Input() public clubs: camps.ClubModel [];

    @Input() public selectedClubId: string;

    @Output() public clubChanged: EventEmitter<camps.ClubModel> = new EventEmitter<camps.ClubModel>();

    constructor() { }

    ngOnInit() {
    }

    public changeClub(value){
        if(!value){
            return;
        }

        this.selectedClubId = value.id;

      var club = this.clubs.find(x=>x.id == value);
        console.log(club);
       this.clubChanged.emit(club);
    }
}
